import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { PrizesScene } from "./PrizesScene";

export class PrizeCell extends Phaser.GameObjects.Container {

    private i: number;

    constructor(scene: Phaser.Scene, i: number) {
        
        super(scene);

        this.i = i;

        const cellBackground = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "present-cell-background");
        this.add(cellBackground);

        const prizeData = GameVars.prizeResults.prizes[this.i];
        
        let itemImg: Phaser.GameObjects.Image;

        if (prizeData.image) {

            itemImg= new Phaser.GameObjects.Image(this.scene, 0, -80, "prize-image-" + prizeData.id);

            const scale = 250 / itemImg.width;
    
            itemImg.setScale(scale);

        } else {
            itemImg = new Phaser.GameObjects.Image(this.scene, 0, -80, "texture_atlas_1", "box_small");
        }

        itemImg.setInteractive();
        itemImg.on("pointerup", () => {
            this.onClickItem();
        }, this);
        this.add(itemImg);

        let name: string;

        if(prizeData.name.length > 35) {
            name = prizeData.name.substr(0, 35) + "...";
        } else {
            name = prizeData.name;
        }

        const nameLabel = new Phaser.GameObjects.Text(this.scene, 0, 120, name, 
            { 
                fontFamily: "FuturaPTBook", 
                fontSize: "50px", 
                color: "#FFE0B1", 
                align: "center",
                wordWrap: { width: 400, useAdvancedWrap: true }
            });
        nameLabel.setOrigin(.5)
        this.add(nameLabel);

        // if (GameConstants.DEVELOPMENT) {
        //     const idLabel = new Phaser.GameObjects.Text(this.scene, 160, -160, "id:" + prizeData.id.toString(), {fontFamily: "Arial", fontSize: "30px", color: "#00FF00"});
        //     idLabel.setOrigin(.5)
        //     this.add(idLabel);
        // }
    }

    private onClickItem(): void {

        const dy = Math.abs(PrizesScene.currentInstance.deltaY);

        if ( dy > 15 ) {
            return;
        }

        GameManager.enterPresentInfoScene(this.i)

        this.scene.sound.playAudioSprite("audio-sprite", "click_btn");      
    }
}
